import { useState } from "react";
import { useGlobalContext } from "../GlobalContext";


function Potongan() {
  const { periode, bulan, api } = useGlobalContext(); 
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  
  const currentYear = periode.toString().substring(0, 4);
  const currentMonth = parseInt(periode.toString().substring(4, 6)) - 1;

  const nextMonth = (currentMonth + 1) % 12;
  const nextYear = currentMonth === 11 ? parseInt(currentYear) + 1 : currentYear;

  const periodenext = nextYear.toString() + (nextMonth + 1).toString().padStart(2, '0');

  const getAnggota = async () => {
    try {
      const response = await api.get('/api/anggota/anggotaaktif') 
      return response.data || [];
    } catch (error) {
      console.error('Error fetching anggota:', error);
      return [];
    }
  };

  const getJumlahSimpanan = async () => {
    try {
      const response = await api.get('/api/setup/simpanan');
      return response.data || [];
    } catch (error) {
      console.error('Error fetching simpanan:', error);
      return [];
    }
  };

  const getJasaPiutang = async () => {
    try {
      const response = await api.get('/api/setup/jasapinjaman');
      return response.data || [];
    } catch (error) {
      console.error('Error fetching simpanan:', error);
      return [];
    }
  };

  const getSimpananSukarela = async () => {
    try {      
      const response = await api.get('/api/setup/simpanansukarela');
      return response.data || [];
    } catch (error) {
      console.error('Error fetching simpanan sukarela:', error);
      return [];
    }
  };

  const getSaldoPiutang = async () => {
    try {
      const response = await api.get('/api/setup/saldopiutang');
      return response.data || [];
    } catch (error) {
      console.error('Error fetching simpanan sukarela:', error);
      return [];
    }
  }

  const handleSubmit = async () => {  
    setLoading(true);
    setMessage("");
    const confirmProcess = window.confirm("Lanjutkan Proses Potongan?");
    if (!confirmProcess) {
      setLoading(false);
      setMessage("Proses dibatalkan.");
      return;
    }  

    try {
      let simppokok, simpwajib, simphariraya, simpvoucher;
      let jasa_a, jasa_b, mtd_a, mtd_b;
      const dataSelect = await getAnggota();        
      const dataSimpanan = await getJumlahSimpanan();
      const jasapinjaman = await getJasaPiutang();
      const dataSimpSukarela = await getSimpananSukarela();
      const dataPiutang = await getSaldoPiutang();

      if (!Array.isArray(dataSelect) || !Array.isArray(dataSimpanan) || !Array.isArray(dataSimpSukarela) || !Array.isArray(dataPiutang) || !Array.isArray(jasapinjaman)) {
        console.error("Data anggota, simpanan, atau sukarela tidak valid");
        setMessage("Gagal mengambil data.");
        return;
      }
      
      try {
        await api.delete(`/api/potongan/${periodenext}`);
      } catch (error) {
        console.error("Gagal menghapus data potongan:", error);
      }

      if (dataSimpanan.length > 0) {
        const simpanan = dataSimpanan[0];
        simppokok = simpanan.spokok;
        simpwajib = simpanan.swajib;
        simphariraya = simpanan.shariraya;
        simpvoucher = simpanan.svbelanja;
      }

      if (jasapinjaman.length > 0) {
        const jasametode = jasapinjaman[0];
        jasa_a = jasametode.jasapinj_a;
        jasa_b = jasametode.jasapinj_b;
        mtd_a = jasametode.metode_a;
        mtd_b = jasametode.metode_b;
      }
      
      let gagal = 0;
      for (const item of dataSelect) {
        let potjasa_a = 0, potjasa_b = 0, potgermen_a = 0;
        const sukarelaData = dataSimpSukarela.find(s => s.noanggota === item.noanggota);
        const piutangData = dataPiutang.find(s => s.noanggota === item.noanggota);
        
        if (piutangData) {
          if (piutangData.sldpiutang_a > 0 || piutangData.pelayanan_a > 0) {
            if (mtd_a === 1) {
              potjasa_a = ((jasa_a / 100) * (piutangData.pinjamanlalu_a + piutangData.pelayanan_a)) * 0.40;
              potgermen_a = ((jasa_a / 100) * (piutangData.pinjamanlalu_a + piutangData.pelayanan_a)) * 0.60;
            } else {
              potjasa_a = ((jasa_a / 100) * piutangData.sldpiutang_a) * 0.40;
              potgermen_a = ((jasa_a / 100) * piutangData.sldpiutang_a) * 0.60;
            }
          }
          if (piutangData.sldpiutang_b > 0 || piutangData.pelayanan_b > 0) {
            if (mtd_b === 1) {
              potjasa_b = ((jasa_b / 100) * (piutangData.pinjamanlalu_b + piutangData.pelayanan_b)) * 0.40;
            } else {
              potjasa_b = (jasa_b / 100) * piutangData.sldpiutang_b;
            }
          }
        }
        const recordPotongan = {
          periodenext: periodenext,
          noanggota: item.noanggota,
          nama: item.nama,
          kode_uk: item.kodeuk,
          spokok: Number(simppokok) || 0,
          swajib: Number(simpwajib) || 0,
          shariraya: Number(simphariraya) || 0,
          potsks: 0,
          potsm: Number(sukarelaData?.potsm) || 0,
          potd2: 0,
          saldopinj_a: Number(piutangData?.sldpiutang_a) || 0,
          saldopinj_b: Number(piutangData?.sldpiutang_b) || 0,
          saldopinj_c: 0,
          angs_a: Number(piutangData?.nilaiangsur_a) || 0,
          angs_b: Number(piutangData?.nilaiangsur_b) || 0,
          angs_c: 0,
          jasa_a: Number(potjasa_a) || 0,
          jasa_b: Number(potjasa_b) || 0,
          jasa_c: 0,
          germen_a: Number(potgermen_a) || 0,
          germen_b: 0,
          germen_c: 0,
          vbelanja: Number(simpvoucher) || 0,
        };
        try {
          await api.post('/api/potongan/addpotongan', recordPotongan);
        } catch (error) {
          console.error("Gagal mengirim data:", error);
          gagal++;
        }
      }
      setMessage(gagal > 0 ? `Proses selesai, ${gagal} data gagal.` : "Proses selesai & sukses.");
      setTimeout(() => {
        localStorage.removeItem('pengguna');
        window.location.href = '/login';
      }, 3000);
    } catch (error) {
      console.error("Error proses potongan:", error);
      setMessage("Terjadi kesalahan saat memproses data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div className="card card-info" style={{ width: "400px" }}>
        <div className="card-header">
          <h5 className="card-title text-center">Proses Potongan</h5>
        </div>
        <div className="card-body">
          <div className="form-group row">
            <label className="col-sm-5 col-form-label">Periode</label>
            <div className="col-sm-5">
              <input type="text" className="form-control" value={`${bulan[currentMonth]} ${currentYear}`} readOnly />
            </div>
          </div>
          <div className="form-group row mt-1">
            <label className="col-sm-5 col-form-label">Periode Selanjutnya</label>
            <div className="col-md-5">
              <input type="text" className="form-control" value={`${bulan[nextMonth]} ${nextYear}`} readOnly />
            </div>
          </div>
        </div>
        <div className="card-footer text-right">
          <button type="button" className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={loading}>
            {loading ? "Memproses..." : "Proses"}
          </button>
          {loading && (
            <div className="text-center mt-2">
              <span className="text-info font-bold">Memproses data, harap tunggu...</span>
            </div>
          )}
          {message && (
            <div className="text-center mt-2">
              <span className="text-success font-bold">{message}</span>
            </div>
          )}
        </div>       
      </div>
    </div>
  );
}

export default Potongan;
